import React, { useState } from "react";
import { ICooperativeDetails } from "../../exports/interfaces";
import useMobile from "../../hooks/useMobile";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import { renderTableExistingFilePreview } from "../../exports/functions";

const CommitteesInfo = ({
  cooperative,
}: {
  cooperative: ICooperativeDetails | null;
}) => {
  const [committeeactiveTab, setCommitteeActiveTab] = useState("Committees");
  const isMobile = useMobile();
  const { canEdit } = usePermission();
  const navigate = useNavigate();
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="primary-color">{committeeactiveTab}</h6>
        {canEdit("cooperatives") && (
          <button
            className="btn px-3 btn-badge fs-small"
            onClick={() =>
              navigate(`/register/edit/${cooperative?.id}`, {
                state: {
                  step: 3,
                  tab:
                    committeeactiveTab === "Executive"
                      ? "executive"
                      : "committees",
                },
              })
            }
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <Pencil size={15} />
            </i>
            {!isMobile && "Edit"}
          </button>
        )}
      </div>
      <div className="row g-3">
        <div className="col-md-12 details-text">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <button
              className="btn btn-badge-border px-3"
              onClick={() => setCommitteeActiveTab("Committees")}
              style={
                committeeactiveTab === "Committees"
                  ? { fontWeight: "bold" }
                  : {}
              }
            >
              Committees
            </button>

            <button
              className="btn btn-badge-border px-3"
              onClick={() => setCommitteeActiveTab("Executive")}
              style={
                committeeactiveTab === "Executive" ? { fontWeight: "bold" } : {}
              }
            >
              Executive
            </button>

            {/* <button className="btn btn-badge-border px-3">Tax</button> */}
          </div>
        </div>
      </div>
      <div className="dashboard-card mt-3">
        <div className="table-responsive admin-table table-checkbox">
          {committeeactiveTab === "Committees" && (
            <table className="table align-middle">
              <thead>
                <tr>
                  <th className="table-xs">S. No.</th>
                  <th className="table-xs"></th>
                  <th className="table-md">Post</th>
                  <th className="table-md">Name</th>
                  <th className="table-md">Father's Name</th>
                  <th className="table-md">Grandfather's Name</th>
                  <th className="table-md">Address and Mobile No.</th>
                  <th className="table-sm">Status</th>
                  <th className="table-sm">Actions</th>
                </tr>
              </thead>

              <tbody>
                {cooperative?.cooperativeandexecutive?.committeemember?.map(
                  (member, index) => (
                    <tr key={member.id ?? index}>
                      <td className="table-xs" title={String(index + 1)}>
                        {index + 1}
                      </td>
                      <td className="table-xs">
                        {member.photoUrl
                          ? renderTableExistingFilePreview(member.photoUrl)
                          : null}
                      </td>
                      <td className="table-md" title={member.position}>
                        {member.position}
                      </td>
                      <td className="table-md" title={member.fullName}>
                        {member.fullName}
                      </td>
                      <td className="table-md" title={member.fatherName}>
                        {member.fatherName}
                      </td>
                      <td className="table-md" title={member.grandmotherName}>
                        {member.grandmotherName}
                      </td>
                      <td
                        className="table-md"
                        title={member.address + ", " + member.mobile}
                      >
                        {member.address + ", " + member.mobile}
                      </td>
                      <td className="table-sm">{member.positionStatus}</td>

                      <td>
                        <div className="d-flex gap-3 align-items-center">
                          <i
                            className="cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                          >
                            <Pencil size={20} />
                          </i>

                          <i
                            className="fa-solid fa-trash text-danger cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                            onClick={() => {
                              // setDeleteId(row.id);
                              //   setShowDelete(true);
                            }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          )}
          {committeeactiveTab === "Executive" && (
            <table className="table align-middle">
              <thead>
                <tr>
                  <th className="table-xs">S. No.</th>
                  <th className="table-xs"></th>
                  <th className="table-md">Post</th>
                  <th className="table-md">Name</th>
                  <th className="table-md">Father's Name</th>
                  <th className="table-md">Grandfather's Name</th>
                  <th className="table-md">Address and Mobile No.</th>
                  <th className="table-sm">Status</th>
                  <th className="table-sm">Actions</th>
                </tr>
              </thead>

              <tbody>
                {cooperative?.cooperativeandexecutive?.executivemember?.map(
                  (member, index) => (
                    <tr key={member.id ?? index}>
                      <td className="table-xs" title={String(index + 1)}>
                        {index + 1}
                      </td>
                      <td className="table-xs">
                        {member.photoUrl
                          ? renderTableExistingFilePreview(member.photoUrl)
                          : null}
                      </td>
                      <td className="table-md" title={member.position}>
                        {member.position}
                      </td>
                      <td className="table-md" title={member.fullName}>
                        {member.fullName}
                      </td>
                      <td className="table-md" title={member.fatherName}>
                        {member.fatherName}
                      </td>
                      <td className="table-md" title={member.grandmotherName}>
                        {member.grandmotherName}
                      </td>
                      <td
                        className="table-md"
                        title={member.address + ", " + member.mobile}
                      >
                        {member.address + ", " + member.mobile}
                      </td>
                      <td className="table-sm">{member.positionStatus}</td>

                      <td className="sticky-action">
                        <div className="d-flex gap-3 align-items-center">
                          <i
                            className="cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                          >
                            <Pencil size={20} />
                          </i>

                          <i
                            className="fa-solid fa-trash text-danger cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                            onClick={() => {
                              // setDeleteId(row.id);
                              //   setShowDelete(true);
                            }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <hr />
    </>
  );
};

export default CommitteesInfo;
